import { Component, EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IWindow } from '@phdsoft/window';
import { ELEMENTSTYPESIDS } from 'projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { DigitalTwinService } from 'src/app/digital-twin/digital-twin.service';
import { WorkableElement } from 'src/app/platform/busines-data/SectionElements/WorkableElement';
import { Vector3 } from 'three';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'phdsoft-change-full-ids-config',
  templateUrl: "./change-full-ids-config.component.html",
  styleUrls: ["./change-full-ids-config.component.scss"]
})
export class ChangeFullIdsConfigComponent {

  public optionsWindow: IWindow = {
    Position: 'favorite',
    PositionMini: '',
    VisibleMini: false,
    Header: {
      Icon: 'info',
      VisibleTitle: false,
      Title: 'New User',
      Visible: true,
    },
    Footer: {
      ShowCancel: false,
      ShowOk: true,
      Visible: true,
    },
  };


  private _fullIdsElements : Array<WorkableElement>;
  public get completedIdsElements() : Array<WorkableElement> {
    return this._fullIdsElements;
  }
  public set completedIdsElements(v : Array<WorkableElement>) {
    this._fullIdsElements = v;
  }


  private _width: number = 1;
  private _height: number = 1;
  private _depth: number = 1;

  public get width(){
    return this._width
  }
  public set width(v: number){
    this._width = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }

  public get height(){
    return this._height
  }
  public set height(v: number){
    this._height = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }

  public get depth(){
    return this._depth
  }
  public set depth(v: number){
    this._depth = parseFloat(v.toFixed(2))
    this.updateBoxDimensions()
  }


  public get formatedWidth(){
    return (this.width * 100).toFixed(0)
  }

  public get formatedHeight(){
    return (this.height * 100).toFixed(0)
  }

  public get formatedDepth(){
    return (this.depth * 100).toFixed(0)
  }

  public get dimensions(){
    return new Vector3(this.width, this.height, this.depth)
  }


  constructor(
    public dialogRef: MatDialogRef<ChangeFullIdsConfigComponent>,
    private assetManager: AssetManager,
    private digitalTwinService: DigitalTwinService,
    private snackBar: MatSnackBar,
  ) {}

  updateBoxDimensions(){
    this.assetManager.updateCriticalAreaBox(this.width, this.height, this.depth)
  }

  submit(){
    this.dialogRef.close()
  }

  onSelectElementFullId() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'FULLIDSELEMENTS';
    } else {
      // this.assetManager.setFunctionalityModeNone()
    }
    console.log('onInspectSelectButtonClick button clicked!');
  }
  onSelectFullIdTarget() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'FULLIDSELEMENTTARGET';
    } else {
      // this.assetManager.setFunctionalityModeNone()
    }
    console.log('onInspectSelectButtonClick button clicked!');
  }

  onTargetSelectButtonClick() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.assetManager.functionalityMode = 'INSPECCHANGETARGET';
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
    console.log('onTargetSelectButtonClick button clicked!');
  }

  onExecuteChangeButtonClick() {
    if (
      this.assetManager.asset.mode === 'SECTIONS'
    ) {
      this.setFullIds();
    } else {
      // this.assetManager.setFunctionalityModeNone()
      // this.assetManagerBoxMeasureTool.clearWeightMeasurementToolMode()
    }
    console.log('onExecuteChangeButtonClick button clicked! CompletedIds');
  }

  save() {
    this.saveCompletedIds();

    console.log('onStopInspectionChangeButtonClick button clicked!');
  }

  cancel() {
    if(this._fullIdsElements){
      for (const element of this._fullIdsElements) {
        element.currentRenderMaterial = element.defaultMaterial;
      }
    }
    if(this.assetManager.fullIdsElements){
      for (const element of this.assetManager.fullIdsElements) {
        element.currentRenderMaterial = element.defaultMaterial;
      }
    }

    if(this.assetManager.fullIdElementTarget != null)
      this.assetManager.fullIdElementTarget.currentRenderMaterial = this.assetManager.fullIdElementTarget.defaultMaterial

    console.log('cancel button clicked!');

    this._fullIdsElements = []
    this.assetManager.fullIdElementTarget = null
    this.assetManager.fullIdsElements = [];
    this.assetManager.setFunctionalityModeNone();
  }


  public  setFullIds(){
    console.log(this.assetManager.fullIdElementTarget)
    console.log(this.assetManager.fullIdsElements)
    if(this.assetManager.fullIdsElements && this.assetManager.fullIdElementTarget && this.assetManager.fullIdElementTarget.properties ){

      let allStiffeners = this.assetManager.fullIdsElements.every(x => x.properties.TypeId === ELEMENTSTYPESIDS.STIFFENER);
      let allBrackets = this.assetManager.fullIdsElements.every(x => x.properties.TypeId === ELEMENTSTYPESIDS.BRACKET);

      if(this.assetManager.fullIdElementTarget.properties.TypeId === ELEMENTSTYPESIDS.STIFFENER && allStiffeners){
        for (const element of this.assetManager.fullIdsElements) {
          element.properties.General.FullStiffenerId = this.assetManager.fullIdElementTarget.properties.General.FullStiffenerId;
          element.properties.General.FullStiffenerLabel = this.assetManager.fullIdElementTarget.properties.General.FullStiffenerLabel;
        }
      }
      else if(this.assetManager.fullIdElementTarget.properties.TypeId === ELEMENTSTYPESIDS.BRACKET && allBrackets){
        for (const element of this.assetManager.fullIdsElements) {
          element.properties.General.FullBracketId = this.assetManager.fullIdElementTarget.properties.General.FullBracketId;
          element.properties.General.FullBracketLabel = this.assetManager.fullIdElementTarget.properties.General.FullBracketLabel;
        }
      }

      if(!this._fullIdsElements)
        this._fullIdsElements = []

      for (const element of this.assetManager.fullIdsElements) {
        if(this._fullIdsElements.findIndex(x => x.Guid === element.Guid) == -1){
          this._fullIdsElements.push(element);
        }
      }

    }
    else if (this.assetManager.fullIdsElements){
      let fullId = uuid() as string;
      let allStiffeners = this.assetManager.fullIdsElements.every(x => x.properties.TypeId === ELEMENTSTYPESIDS.STIFFENER);
      let allBrackets = this.assetManager.fullIdsElements.every(x => x.properties.TypeId === ELEMENTSTYPESIDS.BRACKET);

      if(allStiffeners){
        let fullLabel = this.assetManager.fullIdsElements[0].properties.General.Label

        for (const element of this.assetManager.fullIdsElements) {
          element.properties.General.FullStiffenerId = fullId;
          element.properties.General.FullStiffenerLabel = fullLabel;
        }
      }
      else if(allBrackets){
        let fullLabel = this.assetManager.fullIdsElements[0].properties.General.Label

        for (const element of this.assetManager.fullIdsElements) {
          element.properties.General.FullBracketId = fullId;
          element.properties.General.FullBracketLabel = fullLabel;
        }
      }

      if(!this._fullIdsElements)
        this._fullIdsElements = []

      for (const element of this.assetManager.fullIdsElements) {
        if(this._fullIdsElements.findIndex(x => x.Guid === element.Guid) == -1){
          this._fullIdsElements.push(element);
        }
      }
    }

    this.snackBar.open('Set Full Id Completed', '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration:3000
    });
  }

  public clear(){
    console.log(this.assetManager.fullIdElementTarget)
    console.log(this.assetManager.fullIdsElements)
    if(this.assetManager.fullIdsElements && this.assetManager.fullIdElementTarget && this.assetManager.fullIdElementTarget.properties ){

      let allStiffeners = this.assetManager.fullIdsElements.every(x => x.properties.TypeId === ELEMENTSTYPESIDS.STIFFENER);
      let allBrackets = this.assetManager.fullIdsElements.every(x => x.properties.TypeId === ELEMENTSTYPESIDS.BRACKET);

      if(this.assetManager.fullIdElementTarget.properties.TypeId === ELEMENTSTYPESIDS.STIFFENER && allStiffeners){
        for (const element of this.assetManager.fullIdsElements) {
          element.properties.General.FullStiffenerId = null;
          element.properties.General.FullStiffenerLabel = null;
        }
      }
      else if(this.assetManager.currentFlangeCompletedId.properties.TypeId === ELEMENTSTYPESIDS.BRACKET && allBrackets){
        for (const element of this.assetManager.fullIdsElements) {
          element.properties.General.FullBracketId = null;
          element.properties.General.FullBracketLabel = null;
        }
      }

      if(!this._fullIdsElements)
        this._fullIdsElements = []

      for (const element of this.assetManager.fullIdsElements) {
        if(this._fullIdsElements.findIndex(x => x.Guid === element.Guid) == -1){
          this._fullIdsElements.push(element);
        }
      }

    }
    else if (this.assetManager.fullIdsElements){
      let fullId = uuid() as string;
      let allStiffeners = this.assetManager.fullIdsElements.every(x => x.properties.TypeId === ELEMENTSTYPESIDS.STIFFENER);
      let allBrackets = this.assetManager.fullIdsElements.every(x => x.properties.TypeId === ELEMENTSTYPESIDS.BRACKET);

      if(allStiffeners){
        let fullLabel = this.assetManager.fullIdsElements[0].properties.General.Label

        for (const element of this.assetManager.fullIdsElements) {
          element.properties.General.FullStiffenerId = null;
          element.properties.General.FullStiffenerLabel = null;
        }
      }
      else if(allBrackets){
        let fullLabel = this.assetManager.fullIdsElements[0].properties.General.Label

        for (const element of this.assetManager.fullIdsElements) {
          element.properties.General.FullBracketId = null;
          element.properties.General.FullBracketLabel = null;
        }
      }

      if(!this._fullIdsElements)
        this._fullIdsElements = []

      for (const element of this.assetManager.fullIdsElements) {
        if(this._fullIdsElements.findIndex(x => x.Guid === element.Guid) == -1){
          this._fullIdsElements.push(element);
        }
      }
    }

    this.snackBar.open('Clear Full Id Completed', '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration:3000
    });
  }

  public async saveCompletedIds(){
    if(this._fullIdsElements && this._fullIdsElements.length > 0){
      await this.digitalTwinService.updatePropertiesList(this._fullIdsElements.map(x => x.properties), this._fullIdsElements[0].regionId, this.assetManager.asset.assetInfo.AssetId);

    }
    this.cancel();
    // this._completedIdsElements = []

    this.snackBar.open('Saving Full Id Completed', '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration:3000
    });
  }
}

